module.exports = __webpack_public_path__ + "img/link-banner-de.f495256d.png";